import InfiniteScroll from 'react-infinite-scroll-component';
import React from 'react'
import Translation from '../global/Translation'
import LocalizedLink from '../global/LocalizedLink'
import Button from '../global/Button'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import Timeline from './Timeline'
import PreOrdersCtsFilters from "./PreOrdersCtsFilters";
import {BudgetMessages} from "../cut-to-size/CutToSizeMaps";
import confirm from "../global/extendedConfirm";
import Spinner from "../global/Spinner";
import ProfileContainer from "../profile/ProfileContainer"
import TranslationWithComponent from '../global/TranslationWithComponent'
import { quotationMessages } from './PreOrdersCtsContainer'
import Alerts from '../alerts/Alerts'
import FloatingAlert from '../alerts/FloatingAlert'

export const StatusList = [
    'REQUESTED',
    'TECHNICAL_REVIEW',
    'CSTMR_APPROVAL',
    // 'CSTMR_PLAN_APPRV',
    'ORDER_PROGRESS',
    'ORDER_CREATED',
    'CANCELLED',
    'CSTMR_CANCEL',
    'EXPIRED',
    'WAIT_REACTIV'
]

const DangerStatusObject = {
    CANCELLED: true,
    CSTMR_CANCEL: true,
    EXPIRED: true,
    WAIT_REACTIV: true
}



export const TimelinePreOrder = (props) => {
    const orderStatusMap = {}
    StatusList.forEach((status, index) => {
        if (StatusList.includes(status)) {
            orderStatusMap[status] = { textToShow: props.intl.formatMessage(quotationMessages[status]), editable: false, pos: index }
        }
    })

    // console.log('orderStatusMap', props.preOrder, props.int)
        // REQUESTED: { textToShow: props.intl.formatMessage(quotationMessages.REQUESTED), editable: false, pos:0 },
        // TECHNICAL_REVIEW: { textToShow: props.intl.formatMessage(quotationMessages.TECHNICAL_REVIEW), editable: false, pos:1 },
        // CSTMR_APPROVAL: { textToShow: props.intl.formatMessage(quotationMessages.CSTMR_APPROVAL), editable: false, pos:2 },
        // CSTMR_PLAN_APPRV: { textToShow: props.intl.formatMessage(quotationMessages.CSTMR_PLAN_APPRV), editable: false, pos:3 },
        // ORDER_CREATED: { textToShow: props.intl.formatMessage(quotationMessages.ORDER_CREATED), editable: false, pos:4 },
        // CANCELLED: { textToShow: props.intl.formatMessage(quotationMessages.CANCELLED), editable: false, pos:5 },
        // CSTMR_CANCEL: { textToShow: props.intl.formatMessage(quotationMessages.CSTMR_CANCEL), editable: false, pos:6 }
    // }

    const getDeliveries = () => {
        const deliveries = []

        const lastRecord = props.preOrder.records.slice(-1)[0];
        const records = {}
        props.preOrder.records.forEach(record => records[record.status] = record)

        if (!lastRecord) return []

        if (DangerStatusObject[lastRecord.status]) {
            Object.entries(orderStatusMap).forEach(([k, v]) => {
                const record = records[k]
                if (record) {
                    deliveries.push({
                        active: getStepStatus(k),
                        alert: false,
                        date: record.created_at,
                        statusText: k,
                        current: props.preOrder.status === k,
                        danger: DangerStatusObject[k]
                    })
                }
            })
        } else {
            Object.entries(orderStatusMap).forEach(([k, v]) => {
                if (!DangerStatusObject[k]) {
                    const date = records[k] && records[k].created_at
                    deliveries.push({
                        active: getStepStatus(k),
                        alert: false,
                        date: date,
                        statusText: k,
                        current: props.preOrder.status === k
                    })
                }
            })
        }

        return deliveries
    }

    const getStepStatus = (stepName) => {
        const stepStatusPos = orderStatusMap[stepName].pos
        const preOrderStatusPos = orderStatusMap[props.preOrder.status].pos

        return stepStatusPos <= preOrderStatusPos
    }

    return <Timeline
        orderStatusMap={orderStatusMap}
        delivery={getDeliveries()}
        withDates
        {...props}
    />
}

export const ExpirationAlert = (props) => {
    if (props.preOrder.status !== 'CSTMR_APPROVAL' && props.preOrder.status !== 'TECHNICAL_REVIEW') return ''

    const currentDate = moment().startOf('day')
    const expirationDate = moment(props.preOrder.expiration_date)
    const diff = expirationDate.diff(currentDate, 'days')
    if (diff > 7) return ''

    const iconClass = diff > 2 ? "fa-exclamation-triangle preorder-alert-icon" : "fa-times-octagon preorder-danger-icon"
    const status = diff > 2 ? "warning" : "danger"
    const message = diff > 2 ?
        <Translation id="quotation_expires_in_n_days"
          defaultMessage="This quote expires in {days} calendar days"
          values={{days: diff}}
        />
        :
        <Translation id="quotation_close_to_expire" defaultMessage="This quotation is close to expire"/>

    return (
        <div className="preorder-alert-container override-margin">
            <Alerts
                status={status}
                cssIcon={`fal ${iconClass}`}
                iconSize="18px"
                iconWrap="preorder-alert-icon-wrap"
                element={
                    <div>
                        <b>{message}</b>&nbsp;
                        (<Translation id="expiration_date" defaultMessage="Expiration date"/>: {expirationDate.format('L')})
                    </div>
                }
                className="preorder-alert"
            ></Alerts>
        </div>
    )
}

class PreOrdersCts extends React.Component {
    state = {
        width: window.innerWidth,
        startDate: null,
        endDate: moment(),
        filterProject: null,
        filterTypeOrder: null,
        showDetails: false,
        search: ''
    }

    componentDidMount() {
        this.props.clearPreOrderCts()
        // this.props.fetchPreOrdersCts()
        this.props.fetchPreOrdersProjectAvailables()
        this.fetchPreOrdersPaginate(true)
    }

    fetchPreOrdersPaginate = (firstPage=false) => {
        this.props.fetchPreOrdersCtsPaginate(
            this.state.startDate && this.state.startDate.utc().startOf('day'),
            this.state.endDate && this.state.endDate.utc().endOf('day'),
            this.state.filterProject,
            this.state.filterTypeOrder,
            this.state.search,
            firstPage ? 1 : this.props.currentPage + 1
        )
    }

    updateFilterValues = (startDate, endDate, filterProject, status, search) => {
        this.setState({
            startDate: startDate,
            endDate: endDate,
            filterProject: filterProject,
            filterTypeOrder: status,
            search: search
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.startDate !== prevState.startDate
        || this.state.endDate !== prevState.endDate
        || this.state.filterProject !== prevState.filterProject
        || this.state.filterTypeOrder !== prevState.filterTypeOrder
        || this.state.search !== prevState.search) {
            this.fetchPreOrdersPaginate(true)
        }
    }

    confirmRejectOrder = preorderId => {
        return confirm(this.props.intl.formatMessage(quotationMessages.CONFIRM_REJECT_ORDER), {
            advise: (
                <React.Fragment>
                    <i className="fal fa-exclamation-triangle"></i>&nbsp;
                    {this.props.intl.formatMessage(quotationMessages.CONFIRM_REJECT_PREORDER_ADVISE)}
                </React.Fragment>
            ),
            textCancel: this.props.intl.formatMessage(quotationMessages.CONFIRM_REJECT_PREORDER_CANCEL_BUTTON),
            textOk: this.props.intl.formatMessage(quotationMessages.CONFIRM_REJECT_PREORDER_OK_BUTTON)
        }).then(
            confirm => {
                this.props.cancelPreorder(preorderId).then(() => this.forceUpdate())
                // .catch(error => alert(error))
            },
            cancel => {
                return Promise.reject()
            }
        )
    }

    confirmReactivateQuotation = preorderId => {
        return confirm(this.props.intl.formatMessage(quotationMessages.CONFIRM_REACTIVATE_QUOTATION), {
            textCancel: this.props.intl.formatMessage({id:'cancel'}),
            textOk: this.props.intl.formatMessage(quotationMessages.CONFIRM_REACTIVATE_QUOTATION_OK_BUTTON)
        }).then(
            confirm => {
                this.props.reactivatePreorder(preorderId).then(() => this.forceUpdate())
                // .catch(error => alert(error))
            },
            cancel => {
                return Promise.reject()
            }
        )
    }

    render() {
        const isMobile = this.state.width <= 768
        const loadMoreButton = (
            <Button onClick={() => this.fetchPreOrdersPaginate()} size="medium" disabled={this.props.currentPage >= this.props.lastPage || this.props.isLoading}>
                {this.props.currentPage >= this.props.lastPage ? (
                    <Translation id="no_more_result" defaultMessage="No more results" />
                ) : (
                    <Translation id="load_more" defaultMessage="Load more" />
                )}
            </Button>
        )
        const unreadedMails = (
            <div
                style={{
                    backgroundColor: '#FF6805',
                    borderRadius: '50%',
                    position: 'absolute',
                    width: '28px',
                    height: '28px',
                    top: '-14px',
                    right: '-12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                className="preorder-unread-msg-icon"
            >
                <i style={{ color: 'white', fontSize: '16px' }} className="fal fa-bell" />
            </div>
        )

        return (
            <React.Fragment>
                <div className="box-profile row">
                    <div className="box-profile-menu col-12 col-md-4 col-lg-3">
                        <ProfileContainer />
                    </div>
                    <div className="col-12 col-xl-9">
                        <div className="prerorder__history--filter-section">
                            <div className="prerorder__history-title">
                                <Translation id="quotation_history" defaultMessage="Quotation history" />
                            </div>
                            <div className="col-12">
                                <PreOrdersCtsFilters
                                    currentPage={this.props.currentPage}
                                    // fetchPreOrdersCtsPaginate={this.props.fetchPreOrdersCtsPaginate}
                                    projectList={this.props.projectList}
                                    orderStatusMap={this.orderStatusMap}
                                    updateFilterValues={this.updateFilterValues}
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    filterProject={this.state.filterProject}
                                    filterTypeOrder={this.state.filterTypeOrder}
                                />
                            </div>
                        </div>

                        <InfiniteScroll
                            dataLength={this.props.preOrdersCts.length}
                            next={() => this.props.currentPage < this.props.lastPage && this.fetchPreOrdersPaginate()}
                            hasMore={true}
                            loader={' '}
                            endMessage={' '}
                        >
                            {this.props.preOrdersCts &&
                                this.props.preOrdersCts.length > 0 &&
                                this.props.preOrdersCts.map(preOrder => {
                                    const hasUnreadedMails = !!preOrder.communications.find(p => p.is_read == 0)
                                    return (
                                        <section key={'preorder-key-' + preOrder.id} className="preorder__history">
                                            {preOrder.expiration_date && <ExpirationAlert preOrder={preOrder}/>}
                                            <div class="preorder__history--header">
                                                <div className="preorder__history--content--summary">
                                                    <div className="summary__project">
                                                        <div className="summary__project--title">
                                                            <Translation id="status" defaultMessage="Status" />:
                                                        </div>
                                                        <div className="summary__project--name">{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</div>
                                                    </div>

                                                    <div className="summary__project">
                                                        <div className="summary__project--title">
                                                            <Translation id="request_id" defaultMessage="Request ID" />:
                                                        </div>
                                                        <div className="summary__project--name">
                                                            {preOrder.reservation_id ? preOrder.reservation_id : <Translation id="pending" defaultMessage="Pending" />}
                                                        </div>
                                                    </div>
                                                    {(preOrder.order_id) ? (
                                                        <div className="summary__project">
                                                            <div className="summary__project--title">
                                                                <Translation id="order_id" defaultMessage="Order ID" />:
                                                            </div>
                                                            <div className="summary__project--name">{preOrder.order_id}</div>
                                                        </div>
                                                    ) : (
                                                        <div className="summary__project">
                                                            <div className="summary__project--title">
                                                                <Translation id="quotation_id" defaultMessage="Quotation ID" />:
                                                            </div>
                                                            <div className="summary__project--name">
                                                                {preOrder.offer_id ? preOrder.offer_id : <Translation id="pending" defaultMessage="Pending" />}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="summary__project">
                                                        <div className="summary__project--title">
                                                            <Translation id="project_type" defaultMessage="Project type" />:
                                                        </div>
                                                        <div className="summary__project--name">{this.props.intl.formatMessage(BudgetMessages[preOrder.project])}</div>
                                                    </div>
                                                    <div className="summary__project">
                                                        <div className="summary__project--title">
                                                            <Translation id="purchase-order" defaultMessage="Your reference" />:
                                                        </div>
                                                        <div className="summary__project--name">{preOrder.purchase_order}</div>
                                                    </div>
                                                    <div className="summary__project text-end">
                                                        <div className="summary__project--title text-end">
                                                            {preOrder.expiration_date && (
                                                                <React.Fragment>
                                                                    <Translation id="expiration_date" defaultMessage="Expiration date" />:
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                        <div className="summary__project--name text-end">{preOrder.expiration_date}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="preorder__history--content row">
                                                <div className="col-12 col-lg-9 preorder__history--content-timeline">
                                                    <div style={{paddingInline: '32px'}}>
                                                        <TimelinePreOrder preOrder={preOrder} intl={this.props.intl} />
                                                        {/*<TimelinePreOrder preOrder={preOrder} intl={this.props.intl} condensed checkMark={!isMobile} />*/}
                                                    </div>
                                                    <div className="mt-5 mt-lg-0" style={{position:'absolute', bottom: '8px'}}>
                                                        <span className="timeline--lastupdate">
                                                            <Translation id="last_update" defaultMessage="Last update" />
                                                            :&nbsp;{moment(preOrder.created_at).format('L')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-12 col-md-12 col-lg-3 preorder__history--content-description">
                                                    {preOrder.status === 'ORDER_PROGRESS' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="were_creating_your_order"
                                                                             defaultMessage="We’re creating your order. You’ll be able to view the details shortly." />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'ORDER_CREATED' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <TranslationWithComponent
                                                                id="order_created_desc"
                                                                defaultMessage="Order created. You can follow its status in ****."
                                                                replaceTex="****"
                                                            >
                                                                <LocalizedLink
                                                                    routeId="ROUTE_PROFILE"
                                                                    params={{
                                                                        filter: 'view-order',
                                                                        open: preOrder.reservation_id
                                                                    }}
                                                                    className="preorder__history--vieworder"
                                                                >
                                                                    <Translation id="order_history"
                                                                                 defaultMessage="Order history" />
                                                                </LocalizedLink>
                                                            </TranslationWithComponent>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'TECHNICAL_REVIEW' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="quotation_review_desc"
                                                                             defaultMessage="Our technical team is reviewing your request." />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'CSTMR_APPROVAL' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation
                                                                    id="available_quotation_desc"
                                                                    defaultMessage="Your quotation is now available. Review and approve it to continue with your order."
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'CSTMR_PLAN_APPRV' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation
                                                                    id="available_plan_desc"
                                                                    defaultMessage="The technical drawing is now available. Review and approve it to continue with your order."
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'REQUESTED' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation
                                                                    id="sent_quotation_desc"
                                                                    defaultMessage="We have received your request. Our technical team will review it shortly to prepare a quotation."
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'CANCELLED' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="canceled_quotation_desc"
                                                                             defaultMessage="This quotation has been canceled." />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'CSTMR_CANCEL' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="canceled_quotation_desc_by_customer"
                                                                             defaultMessage="This quotation has been canceled by you." />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'WAIT_REACTIV' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="quotation_reactivation_requested"
                                                                             defaultMessage="Your reactivation request has been submitted. This process will take a few minutes, and once it is complete, you can proceed with your quotation."
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                    {preOrder.status === 'EXPIRED' && (
                                                        <div>
                                                            <h5>{this.props.intl.formatMessage(quotationMessages[preOrder.status])}</h5>
                                                            <span>
                                                                <Translation id="quotation_expired_on_desc"
                                                                             defaultMessage="This quotation expired on {date} after exceeding its 30-day validity period. If you wish to continue with your request, you can request reactivation by clicking the button."
                                                                             values={{ date: preOrder.expiration_date }}
                                                                />
                                                            </span>
                                                        </div>
                                                    )}

                                                    <div className="preorder__history--btn-container">
                                                        <LocalizedLink routeId="ROUTE_PROFILE" params={{
                                                            filter: 'pre-orders-cts-details',
                                                            open: preOrder.id
                                                        }}>
                                                            <Button
                                                                className="bt-dark no-bo preorder__history--viewdetails">
                                                                <Translation id="view_detail"
                                                                             defaultMessage="View detail" />
                                                                <i className="far fa-chevron-right"></i>
                                                            </Button>
                                                        </LocalizedLink>
                                                        {hasUnreadedMails && unreadedMails}
                                                    </div>

                                                    {preOrder.status === 'EXPIRED' && (
                                                        <div className="preorder__history--btn-container"
                                                             onClick={() => this.confirmReactivateQuotation(preOrder.id)}>
                                                            <Button
                                                                className="bt-dark no-bo preorder__history--viewdetails">
                                                                <Translation id="reactivate_quotation_request"
                                                                             defaultMessage="Reactivate quotation request" />
                                                            </Button>
                                                        </div>
                                                    )}

                                                    {preOrder.isCancelable && (
                                                        <Button className="preorder__history--cancel"
                                                                onClick={() => this.confirmRejectOrder(preOrder.id)}>
                                                            {/*<i className="fal fa-times"/>&nbsp;&nbsp;*/}
                                                            <Translation id="cancel_quotation"
                                                                         defaultMessage="Cancel quotation" />
                                                        </Button>
                                                    )}


                                                </div>
                                            </div>
                                        </section>
                                    )
                                })}
                        </InfiniteScroll>
                        <div className="row">
                            <div className="col-12 mb-4 pt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                {loadMoreButton}
                            </div>
                        </div>
                    </div>
                    <Spinner isLoading={this.props.isLoading}></Spinner>
                    {this.props.showPreOrderCommunicationAlert && (
                        <FloatingAlert
                            failureMessage={this.props.communicationError}
                            onClose={() => this.props.hideCommunicationAlert()}
                        />
                    )}
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(PreOrdersCts)
